import { render, staticRenderFns } from "./PODataTable.vue?vue&type=template&id=6dfdec60&scoped=true"
import script from "./PODataTable.vue?vue&type=script&lang=ts"
export * from "./PODataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdec60",
  null
  
)

export default component.exports